import { Pipe, PipeTransform } from "@angular/core";

const PADDING = "000000";

@Pipe({ name: "twoDecimalPoint" })
export class NumFormatter implements PipeTransform {

  private PREFIX: string
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;
  private SUFFIX: string
  
  constructor() {
    // TODO comes from configuration settings
    this.PREFIX = ''
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
    this.SUFFIX = ''
  }

  transform(value: string, isNumberInput: boolean = false, fractionSize: number = 2): string {
    /* added .toString() as value may be integer/non-string 
       added checking for null/undefined then "0" */
    value = value ? value.toString() : "0";
    if (!isNumberInput)
      return this.PREFIX + (Number(value).toFixed(fractionSize)).replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR) + this.SUFFIX;
    else 
      return this.PREFIX + (Number(value).toFixed(fractionSize)) + this.SUFFIX;


    // let [ integer, fraction = "" ] = (value || "").toString()
    //   .split(".");

    // fraction = fractionSize > 0
    //   ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
    //   : "";

    // integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

    // return this.PREFIX + integer + fraction + this.SUFFIX;
  }

  parse(value: string, fractionSize: number = 2): string {
    let [ integer, fraction = "" ] = (value || "").replace(this.PREFIX, "")
                                                  .replace(this.SUFFIX, "")
                                                  .split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");

    fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
      : "";

    return integer + fraction;
  }

}


// WEBPACK FOOTER //
// ./src/filters/num-formatter.pipe.ts